import React from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

export interface ScrollTargetProps {
  id: string;
  headerOffset?: number;
}

export const ScrollTarget = ({ id, headerOffset = 50 }: ScrollTargetProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const offset = isDesktop ? headerOffset : 0;
  // Safari doesn't like empty spans, so we use a div instead
  return <div id={id} style={{ position: 'relative', top: -offset }} />;
};
